var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
var SlideImagesLazy = /** @class */ (function (_super) {
    __extends(SlideImagesLazy, _super);
    function SlideImagesLazy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.image = '';
        _this.opened = false;
        _this.currentImage = 1;
        return _this;
    }
    SlideImagesLazy.prototype.beforeMount = function () {
        this.image = this.lazyImages[0]['url'];
    };
    SlideImagesLazy.prototype.previous = function () {
        if (this.currentImage > 1) {
            this.currentImage -= 1;
        }
        // this.image = this.lazyImages[this.currentImage]['url'];
    };
    SlideImagesLazy.prototype.next = function () {
        if (this.currentImage < this.imagesCount) {
            this.currentImage += 1;
        }
        // this.image = this.lazyImages[this.currentImage]['url'];
    };
    SlideImagesLazy.prototype.slideStyle = function () {
        return {
            transform: "translateX(-" + String((this.currentImage - 1) * 100) + "%)"
        };
    };
    SlideImagesLazy.prototype.fullscreenStyle = function () {
        return {
            display: (this.opened && "block") || (!this.opened && "none")
        };
    };
    SlideImagesLazy.prototype.changeFullscreenState = function () {
        if (this.fullscreen) {
            this.opened = !this.opened;
        }
    };
    __decorate([
        Prop()
    ], SlideImagesLazy.prototype, "imagesCount", void 0);
    __decorate([
        Prop()
    ], SlideImagesLazy.prototype, "lazyImages", void 0);
    __decorate([
        Prop()
    ], SlideImagesLazy.prototype, "fullscreen", void 0);
    SlideImagesLazy = __decorate([
        Component({
            components: {}
        })
    ], SlideImagesLazy);
    return SlideImagesLazy;
}(Vue));
export default SlideImagesLazy;
